var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E74C3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2482_19664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3517 25.8424C37.6244 26.4606 38.8244 27.2363 39.9396 28.1576L38.6426 29.4545C37.9396 28.8848 37.1759 28.3757 36.3638 27.9151V25.8424H36.3517ZM20.3638 25.8424V27.903C19.5759 28.3515 18.8123 28.8606 18.0971 29.4424L16.8002 28.1454C17.9032 27.2363 19.1032 26.4727 20.3638 25.8424ZM28.3638 21.5757C22.8608 21.5757 17.8668 23.7333 14.1699 27.2363C13.9517 27.4545 13.8184 27.7576 13.8184 28.097C13.8184 28.4363 13.9517 28.7394 14.1699 28.9454L17.1759 31.9515C17.3941 32.1697 17.6971 32.303 18.0365 32.303C18.3638 32.303 18.6668 32.1818 18.885 31.9636C19.8426 31.0788 20.9214 30.3151 22.1093 29.7212C22.5093 29.5273 22.7881 29.103 22.7881 28.6303V24.8727C24.5456 24.303 26.4244 24 28.3638 24C30.3032 24 32.182 24.303 33.9274 24.8848V28.6424C33.9274 29.1273 34.2062 29.5394 34.6062 29.7333C35.7941 30.3273 36.885 31.0788 37.8426 31.9757C38.0608 32.1818 38.3638 32.3151 38.6911 32.3151C39.0305 32.3151 39.3335 32.1818 39.5517 31.9636L42.5577 28.9576C42.7759 28.7394 42.9093 28.4363 42.9093 28.097C42.9093 27.7576 42.7759 27.4545 42.5577 27.2363C38.8608 23.7333 33.8668 21.5757 28.3638 21.5757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2482_19664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.0909,
    height: 29.0909,
    fill: "white",
    transform: "translate(13.8184 13.0909)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call_end.b8451cfe5675cf34fccbb87a03fd51ec.svg";
export { ForwardRef as ReactComponent };